import React, { useEffect } from "react";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";

const NotificationSnackbar = () => {
  const notification = useSelector((state) => state.notification);
  const { isNotificationReceived, Notification } = notification;
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    if (isNotificationReceived) {
      enqueueSnackbar(
        <div>
          {Notification?.title} <br />
          {Notification?.body}
        </div>,
        {
          variant: "default",
          autoHideDuration: 5000,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
        }
      );
    }
  }, [isNotificationReceived]);

  return <></>;
};

export default NotificationSnackbar;
